import {
  ADD_LESSON_REQUEST,
  ADD_LESSON_SUCCESS,
  ADD_LESSON_FAILURE,
} from "../Actions/lessonActions";

const initialState = {
  loading: false,
  success: false,
  error: null,
  newLesson: null,
};

const addLessonReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LESSON_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case ADD_LESSON_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        newLesson: action.payload,
      };
    case ADD_LESSON_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default addLessonReducer;
